export default __webpack_public_path__ + "static/media/ConveyorMk2.256.f441e2d9.png";